import Styles from './ImageEditor.module.scss'
import { Close, Trash2 } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface TextHotspotPopoverViewProps {
  prompt: string
  /** True when this hotspot already has a saved "describe change" (update) edit; allows confirming an empty field to clear it. */
  hasDescribeEdit: boolean
  onPromptChange: (value: string) => void
  onDeleteText: () => void
  onConfirm: () => void
  close: () => void
}

export const TextHotspotPopoverView = ({
  prompt,
  hasDescribeEdit,
  onPromptChange,
  onDeleteText,
  onConfirm,
  close,
}: TextHotspotPopoverViewProps) => {
  const trimmed = prompt.trim()
  const canConfirm = trimmed.length > 0 || (hasDescribeEdit && trimmed.length === 0)

  return (
    <div className={Styles.editTextPopover}>
      <IconButton
        variant="secondary"
        size="sm"
        icon={Close}
        aria-label="Close"
        onPress={close}
        className={Styles.editTextClose}
      />
      <textarea
        className={Styles.textHotspotDescribeInput}
        name="describeTextChange"
        value={prompt}
        onChange={(e) => onPromptChange(e.target.value)}
        rows={3}
        placeholder="Describe a change"
        aria-label="Describe a change"
        autoComplete="off"
      />
      <div className={Styles.textHotspotActions}>
        <Button
          variant="tertiary"
          size="md"
          className={Styles.textHotspotDelete}
          onPress={onDeleteText}
          aria-label="Delete Text"
          frontIcon={Trash2}
        >
          Delete Text
        </Button>
        <Button
          variant="primary"
          size="md"
          className={Styles.editTextConfirm}
          onPress={onConfirm}
          isDisabled={!canConfirm}
          aria-label="Confirm"
        >
          Confirm
        </Button>
      </div>
    </div>
  )
}
